import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Ursus Victor LLC</title>
        <meta name="description" content="Privacy Policy for Ursus Victor LLC. Learn how we collect, use, and protect your personal information." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            Privacy Policy
          </h1>
          <p style={{fontSize: '1.1rem', opacity: 0.95}}>
            Last Updated: December 4, 2024
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              1. Introduction
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Ursus Victor LLC ("we," "our," or "us") respects your privacy and is committed to protecting 
              your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard 
              your information when you visit our website or use our loan application support services.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              2. Information We Collect
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              We collect information that you provide directly to us, including:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Personal identification information (name, email address, phone number)</li>
              <li>Business information (business name, industry, revenue)</li>
              <li>Financial information necessary for consultation services</li>
              <li>Communication preferences and consent records</li>
              <li>Any other information you choose to provide</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              3. How We Use Your Information
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              We use the information we collect to:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Provide, maintain, and improve our consulting services</li>
              <li>Process and respond to your inquiries and consultation requests</li>
              <li>Send you information about our services, updates, and promotional materials</li>
              <li>Connect you with appropriate financial institutions and lenders</li>
              <li>Comply with legal obligations and protect our legal rights</li>
              <li>Detect, prevent, and address fraud or security issues</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              4. Information Sharing and Disclosure
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              We may share your information with:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li><strong>Financial Institutions:</strong> We share your information with verified lenders and financial 
              institutions to facilitate funding opportunities</li>
              <li><strong>Service Providers:</strong> Third-party vendors who perform services on our behalf</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with any merger, sale, or transfer of our business</li>
            </ul>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginTop: '1rem'}}>
              We do not sell your personal information to third parties.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              5. Data Security
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We implement appropriate technical and organizational security measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over 
              the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              6. Your Rights and Choices
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              You have the right to:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Access and receive a copy of your personal information</li>
              <li>Correct inaccurate or incomplete information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt out of marketing communications</li>
              <li>Withdraw consent for SMS communications by replying STOP</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              7. Cookies and Tracking Technologies
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We use cookies and similar tracking technologies to track activity on our website and hold certain information. 
              You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              8. Third-Party Links
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Our website may contain links to third-party websites. We are not responsible for the privacy practices 
              or content of these third-party sites. We encourage you to review their privacy policies.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              9. Children's Privacy
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal 
              information from children under 18. If you become aware that a child has provided us with personal information, 
              please contact us.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              10. Changes to This Privacy Policy
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new 
              Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy 
              Policy periodically for any changes.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              11. Contact Us
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              If you have any questions about this Privacy Policy, please contact us:
            </p>
            <div style={{
              background: '#f0fdf4',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981'
            }}>
              <p style={{fontSize: '1rem', color: '#065f46', marginBottom: '0.5rem'}}>
                <strong>Miranda Landa Services LLC</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#065f46', marginBottom: '0.5rem'}}>
                Privacy Inquiries: <a href="mailto:privacy@mirandaconnects.com" style={{color: '#059669'}}>privacy@mirandaconnects.com</a>
              </p>
              <p style={{fontSize: '1rem', color: '#065f46'}}>
                General Contact: <a href="mailto:info@mirandaconnects.com" style={{color: '#059669'}}>info@mirandaconnects.com</a>
              </p>
            </div>
          </div>

          <div style={{
            background: '#fef3c7',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #f59e0b',
            textAlign: 'center'
          }}>
            <p style={{fontSize: '1rem', color: '#78350f', lineHeight: '1.7'}}>
              <strong>Your privacy is important to us.</strong> We are committed to protecting your personal information 
              and being transparent about our data practices.
            </p>
          </div>

          <div style={{marginTop: '3rem', textAlign: 'center'}}>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.1rem',
              display: 'inline-block'
            }}>
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy;
